module.exports = {"share":{"rowsPerPage":"จำนวน","rangeSeparator":"จาก","noData":"ไม่มีข้อมูล","addWork":"เพิ่มรายการ","startDate":"วันที่เริ่มต้น","dueDate":"วันที่สิ้นสุด","dateRang":"ระยะเวลา","updateBy":"แก้ไขโดย","lastUpdateBy":"แก้ไขล่าสุดโดย","updateDate":"วันที่แก้ไข","activity":"กิจกรรม","remark":"หมายเหตุ","searchOneDeive":"ค้นหาไฟล์ OneDeive","fileName":"ชื่อไฟล์","action":"ตัวเลือก","download":"ดาวน์โหลด","createDate":"วันที่สร้าง"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/th/share.json
// module id = 945
// module chunks = 108